import gql from "graphql-tag";
import {
  FRAGMENT_MEDIA_ITEM,
  FRAGMENT_NEIGHBORHOOD_DETAILS,
} from "./fragments.js";

export const GET_PLAN = gql`
  ${FRAGMENT_MEDIA_ITEM}
  ${FRAGMENT_NEIGHBORHOOD_DETAILS}
  query GetPlan($uri: ID!) {
    plan(id: $uri, idType: URI) {
      databaseId
      id
      title
      floorplanDetails {
        planNotAvailable
        basePrice
        bathroomsMax
        bathroomsMin
        bedroomsMax
        bedroomsMin
        collection
        displayTitle
        altadenaFloorplan
        finishedSqrFt
        garage
        garageMin
        garage
        garageType
        homeType
        hubspotValue
        mainSqrFt
        matterportTour
        matterportTourTitle
        matterportTour2
        matterportTour2Title
        pdfEPub
        type
        virtualTour
        elevations {
          ...MediaItemFragment
        }
        galleryItems {
          image {
            ...MediaItemFragment
          }
        }
        plansAlternatingContent {
          plansSplitTitle
          plansSplitDescription
          plansSplitButton
          plansSplitButtonText
          plansSplitButtonUrl
          plansSplitImage {
            ...MediaItemFragment
          }
        }
        neighborhood {
          ...NeighborhoodDetailsFragment
        }
        tabs {
          title
          image {
            ...MediaItemFragment
          }
        }
        popularPlans {
          ... on Plan {
            title
            uri
            floorplanDetails {
              planNotAvailable
              bathroomsMax
              bathroomsMin
              bedroomsMax
              bedroomsMin
              mainSqrFt
              finishedSqrFt
              elevations {
                ...MediaItemFragment
              }
            }
          }
        } 
      }
      productStatus {
        enableSnipeLink
        fieldGroupName
        sectionId
        statusCustom
        statusMessage
      }
    }
    collectionFeatures
    plans(last: 500) {
      nodes {
        databaseId
        id
        title
        uri
        floorplanDetails {
          planNotAvailable
          bathroomsMax
          bathroomsMin
          bedroomsMax
          bedroomsMin
          collection
          displayTitle
          finishedSqrFt
          mainSqrFt
          altadenaFloorplan
          elevations {
            ...MediaItemFragment
          }
          features {
            feature
          }
          neighborhood {
            ... on Neighborhood {
              databaseId
              id
              slug
              title
            }
          }
        }
        productStatus {
          enableSnipeLink
          fieldGroupName
          sectionId
          statusCustom
          statusMessage
        }
      }
    }
    homes(last: 500) {
      nodes {
        databaseId
        slug
        title
        uri
        collection {
          collection
          fieldGroupName
        }
        qmiHomeDetails {
          address1
          address2
          city
          bathrooms
          bedrooms
          finishedSqrFt
          latitude
          longitude
          mainSqrFt
          price
          elevations {
            altText
            mediaDetails {
              sizes {
                file
                fileSize
                height
                mimeType
                name
                sourceUrl
                width
              }
            }
            sourceUrl
          }
          floorplan {
            ... on Plan {
              databaseId
              id
              slug
              title
            }
          }  
        }
        productStatus {
          enableSnipeLink
          fieldGroupName
          sectionId
          statusCustom
          statusMessage
        }
      }
    }   
  }
`;
